import { AppConstants, GetWebServiceUrl } from "../utils/constants";
import axios from "axios";
import NotificationHeader, { SetNotificationWithoutDismiss } from "../utils/notification";
import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { Button } from "antd";
import CodeBlock from "./code";
import { Upload, Icon, message } from 'antd';
import { CloudUploadOutlined } from "@ant-design/icons";
const Dragger = Upload.Dragger;

const props = {
    name: 'file',
    multiple: true,
    showUploadList: false,
};

async function start(userData, onEnd) {
    console.log("fetchData")

    let response = await axios.post(GetWebServiceUrl(AppConstants.START_TASK, userData)).catch(err => {
        console.log("ERR", err)
        SetNotificationWithoutDismiss("Error", err.response.status + "\n" + JSON.stringify(err.response.data.message), "danger");
    })
    onEnd()
    return response;
}



async function fetchUserData(userData, onEnd) {
    console.log("fetchData")

    let response = await axios.get(GetWebServiceUrl(AppConstants.GET, userData)).catch(err => {
        console.log("ERR", err)
        return
        // SetNotificationWithoutDismiss("Error", err.response.status + "\n" + JSON.stringify(err.response.data.message), "danger");
    })
    onEnd(response)
    return response;
}


export default function MainPage() {
    const [searchParams, setSearchParams] = useSearchParams()
    const userData = searchParams.get("data");
    const [showQuestion, setShowQuestion] = useState(false)
    const [user, setUser] = useState({})
    const [time, setTime] = useState(0);
    const [isEnd, setIsEnd] = useState(false);

    useEffect(() => {
        fetchUserData(userData, (response) => {
            console.log(response.data)
            if (response === undefined) {
                return
            }
            setUser(response.data)
            setTime(response.data.remaining_time);
            if (response.data.start_date !== null) {
                setShowQuestion(true)
            }
            if (response.data.upload_date !== null) {
                setIsEnd(true)
            }
        })
        let timer = setInterval(() => {
            setTime((time) => {
                if (time === 0) {
                    clearInterval(timer);
                    return 0;
                } else return time - 1;
            });
        }, 1000);
    }, []);

    if (userData === undefined ||
        userData === null ||
        userData === "") {
        return
    }
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.round(time % 60);

    if (!showQuestion) {
        return (
            <>
                <NotificationHeader></NotificationHeader>
                <div>
                    <h1>Snappfood!</h1>
                    <p>برای شروع روی دکمه زیر کلیک کنید</p>
                    <Button type="primary" onClick={() => start(userData, () => {
                        fetchUserData(userData, (response) => {
                            console.log(response.data)
                            if (response === undefined) {
                                return
                            }
                            setUser(response.data)
                            setTime(response.data.remaining_time);
                            if (response.data.start_date !== null) {
                                setShowQuestion(true)
                            }
                            if (response.data.upload_date !== null) {
                                setIsEnd(true)
                            }
                        })
                    })}>شروع</Button>
                </div>
            </>
        )
    } else {
        if (isEnd) {
            return (
                <>
                    <p>درخواست شما ارسال شده است</p>
                </>
            )
        } else {
            return (
                <>
                    <NotificationHeader></NotificationHeader>

                    <div style={{ position: "fixed", top: "0", width: "100%", margin: "auto", height: "300px", background: "white", boxShadow: "0px 10px #888888", zIndex: "1" }}>
                        <div style={{ marginTop: 16, height: 180, zIndex: 99999, direction: "rtl" }}>
                            <Dragger {...props} action={GetWebServiceUrl(AppConstants.UPLOAD, userData)} onChange={(info) => {
                                const status = info.file.status;
                                if (status !== 'uploading') {
                                    console.log(info.file, info.fileList);
                                }
                                if (status === 'done') {
                                    message.success(`${info.file.name} با موفقیت آپلود شد`);
                                    fetchUserData(userData, (response) => {
                                        console.log(response.data)
                                        if (response === undefined) {
                                            return
                                        }
                                        setUser(response.data)
                                        setTime(response.data.remaining_time);
                                        if (response.data.start_date !== null) {
                                            setShowQuestion(true)
                                        }
                                        if (response.data.upload_date !== null) {
                                            setIsEnd(true)
                                        }
                                    })
                                } else if (status === 'error') {
                                    message.error(`${info.file.name} آپلود نشد`);
                                }
                            }
                            }>
                                <p className="ant-upload-drag-icon">
                                    {/* <Icon type="inbox" /> */}
                                    <CloudUploadOutlined />
                                </p>
                                <p className="ant-upload-text">با کلیک یا درگ کردن میتوانید فایل خود را آپلود کنید</p>
                                <p className="ant-upload-hint">لطفا یک فایل با فرمت zip آپلود کنید</p>
                            </Dragger>
                        </div>
                        <p style={{ direction: "rtl" }}>زمان باقیمانده:
                            <span style={{ fontWeight: "bold" }}>
                                {`${hours}h ${minutes}m ${seconds}s`}
                            </span></p>
                    </div>
                    <CodeBlock></CodeBlock>
                </>
            )
        }
    }
}